import cn from './cn';
import en from './en';
import jp from './jp';
import tw from './tw';

export default {
    cn,
    en,
    jp,
    tw,
};
